import React from "react";
import BillBody from "../BillBody";
import Nav from "../Nav"
import Footer from "../Footer"

export default function BillPage(){

    return(
        <div>
            <Nav />
           <BillBody/>
            <Footer />
        </div>


    );



}